import React from 'react';
import CTABannerCompShowcase from '../Views/CTABannerCompShowcase';

/**
 * MultimediaCompDemoView - Route component for the Multimedia Comp Showcase
 * Simple wrapper that renders the MultimediaCompDemo component
 */
const CTABannerCompShowcaseView = () => {
  return <CTABannerCompShowcase />;
};

export default CTABannerCompShowcaseView;
